module.exports = __webpack_public_path__ + "static/media/work-next-arrow-icon.7213b7ec.svg";